import styled from "react-emotion"

const FormSection = styled("div")`
    margin: ${props => props.theme[props.spacing || "small"]} 0px;
`

FormSection.displayName = "FormSection"
export default FormSection



// WEBPACK FOOTER //
// ./src/ui/components/FormSection.js